/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamRevisionReviewMutationRequest,
  PostApiV1ExamRevisionReviewMutationResponse,
  PostApiV1ExamRevisionReview400,
  PostApiV1ExamRevisionReview401,
  PostApiV1ExamRevisionReview500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionReview.ts";

function getPostApiV1ExamRevisionReviewUrl() {
  const res = { method: "POST", url: `/api/v1/exam/revision/review` as const };
  return res;
}

/**
 * @description Salva as alterações de revisão da prova gerada por IA (pt-BR): atualiza título, instrução, questões e opções. Propaga a correção das respostas para as questões traduzidas por índice e aciona a tradução automática para idiomas cujo conteúdo esteja vazio ou quando solicitado via 'shouldTranslate'. **(Requer Authorization para autenticação)**
 * @summary Salvar revisão da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/review}
 */
export async function postApiV1ExamRevisionReview(
  data?: PostApiV1ExamRevisionReviewMutationRequest,
  config: Partial<RequestConfig<PostApiV1ExamRevisionReviewMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ExamRevisionReviewMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionReview400
      | PostApiV1ExamRevisionReview401
      | PostApiV1ExamRevisionReview500
    >,
    PostApiV1ExamRevisionReviewMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamRevisionReviewUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
